// theme.ts
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                // size: "small",
                variant: "outlined",
            },
        },
        MuiSelect: {
            defaultProps: {
                // size: "small",
                variant: "outlined",
            },
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                // size: "small",
                variant: "outlined",
                fullWidth: true,
            },
        },
        MuiDatePicker: {
            defaultProps: {
                slotProps: {
                    textField: {
                        // size: "small",
                        variant: "outlined",
                        fullWidth: true,
                    },
                },
            },
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                    },
                },
            },
        },

    },
});

export default theme;
